import { Menu as SemanticMenu } from 'semantic-ui-react';
import styled from 'styled-components';

const Menu = styled(SemanticMenu)`
  &&&& {
    font-family: Roboto;

    .active.item {
      border-bottom: 2px solid ${(props) => props.theme.color.primary};
      font-weight: 500;

      :hover {
        border-bottom: 2px solid ${(props) => props.theme.color.primary};
      }
    }
  }
`;

Menu.Item = styled(SemanticMenu.Item)`
  color: ${(props) => props.theme.color.text} !important;
`;

export default Menu;
